export const linkToVolumeCustomReportDetail = (reportId = ":reportId") =>
  `/app/volume/custom-reports/${reportId}/detail`;
